module.exports = __webpack_public_path__ + "img/ar14.a13d7204.jpg";